import type { AblyConnectionState } from "@remi/enums/ably-connection-state";

export const InactiveAblyConnectionStateValues = [
  "disconnected",
  "suspended",
  "closing",
  "closed",
  "failed",
] as const satisfies AblyConnectionState[];
